import { showFailed } from "../../Customs/SweetAlerts";
import axiosInstance from "../../Middleware/AxiosInstanceInterceptor";



export const fetchArbitrationDetails = async ({
  page = 1,
  limit = 10,
  cd_Case_ID = "",
}) => {
  try {
    const params = { page, limit };

    // ✅ Only attach filter if search has value
    if (cd_Case_ID && cd_Case_ID.trim() !== "") {
      params.cd_Case_ID = cd_Case_ID.trim();
    }

    const response = await axiosInstance.get(
      "/arbitration-management/getAllArbitration",
      {
        params,
        headers: {
          "module-id": "commence",
        },
      }
    );

    return response.data;
  } catch (error) {
    showFailed("Failed.", error.response?.statusText || "Server Error");
    throw error;
  }
};


export const fetchScheduledArbitrations = async ({
  page = 1,
  limit = 10,
  cd_Case_ID = "",
}) => {
  try {
    const response = await axiosInstance.get(
      "/arbitration-management/getAllScheduleArbitrations",
      {
        params: {
          page,
          limit,
          cd_Case_ID,
        }, headers: {
      "module-id": "commence"
    }
      }
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log("Schedule Arbitration Error:", error);
    throw error;
  }
};

export const fetchExpiredArbitrations = async ({
  page = 1,
  limit = 10,
  cd_Case_ID = "",
  vc_room_number = "",
}) => {
  try {
    const params = { page, limit };

    if (cd_Case_ID?.trim()) {
      params.cd_Case_ID = cd_Case_ID.trim();
    }

    if (vc_room_number?.trim()) {
      params.vc_room_number = vc_room_number.trim();
    }

    const response = await axiosInstance.get(
      "/arbitration-management/getExpiredScheduleArbitrations",
      {
        params,
        headers: {
          "module-id": "commence",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log("Expired Arbitration Error:", error);
    throw error;
  }
};



// Get CMS User by ID
export const getArbitrationDetailById = async (userId) => {
    try {
        const response = await axiosInstance.get(`/arbitration-managment/${userId}`);
        const data = response.data;

        if (response.status === 200) {
            return data;
        } else {
            showFailed('Failed.', `${response.status}`);
            throw new Error("Failed to fetch data. Status: " + response.status);
        }
    } catch (error) {
        showFailed('Failed.', `${error.response.data.error[0]}`);
        throw new Error('Error retrieving user data:', error);
    }
};

export const uploadArbitratorDocument = async (formData) => {
  try {
    const response = await axiosInstance.patch(
      "/arbitration-management/arbitrator_doc_cms",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "module-id": "commence",
        },
      }
    );

    return response.data;
  } catch (error) {
    showFailed("Upload Failed", error.response?.data?.message || "Server Error");
    throw error;
  }
};

// Add Commence Arbitration
export const addCommenceArbitration = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/arbitration-management/addCommenceV2",
      data,
      {
        headers: {
          "module-id": "commence",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      return response.data;
    }
  } catch (error) {
    console.log("Add Commence Error:", error);

    showFailed(
      "Failed.",
      error.response?.data?.message || "Unable to add arbitration"
    );

    throw error;
  }
};